/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import settings from 'settings'

import Icon from 'app/views/components/Icon'

class SortCustomAssessmentContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedItemContent: {},
    }
  }

  renderSortableContent() {
    const { selectedContent } = this.props
    const { selectedItemContent } = this.state
    return (
      <ul
        id="sorted-assessment-content"
        uk-sortable="handle: .uk-sortable-handle"
        className="uk-padding-small"
      >
        {
          Object.keys(selectedContent).map((contentUUID) => {
            const content = selectedContent[contentUUID] || {}
            return (
              <li
                key={contentUUID}
                data-uuid={contentUUID}
                className="uk-card uk-card-default uk-card-small uk-text-small uk-flex uk-flex-row"
                style={{
                  padding: 0,
                  marginTop: 20,
                  cursor: 'pointer',
                  borderLeft: 'solid 5px #1e87f0',
                  boxSizing: 'border-box',
                }}
              >
                <div style={{ flex: 1, cursor: 'move' }} className="uk-flex uk-flex-middle uk-flex-center uk-sortable-handle">
                  <Icon
                    name="menu"
                    className="uk-margin-small-right"
                  />
                </div>
                <div style={{ flex: 4, padding: 10 }}>
                  <span
                    className="uk-text-secondary"
                  >
                    {content.title}
                  </span>
                  <br />
                  <i>
                    {`${settings.engines[content.language]} / ${settings.frameworks[content.framework]}`}
                  </i>
                </div>
                <div
                  style={{ flex: 3.5 }}
                  className="uk-flex uk-flex-middle uk-flex-between"
                >
                  <div
                    className="uk-flex uk-flex-column"
                  >
                    <div
                      className="uk-flex uk-flex-row uk-flex-middle"
                    >
                      <input
                        data-test-id="input-time-limit"
                        className="uk-input uk-form-small uk-text-center uk-margin-remove uk-text-emphasis"
                        type="text"
                        style={{
                          width: 100,
                        }}
                        placeholder="No limit"
                        onChange={(e) => {
                          this.props.onChangeTimeLimit(contentUUID, e.target.value)
                        }}
                        value={selectedContent[contentUUID].timeLimit || ''}
                      />
                      <span
                        className="uk-margin-small-left uk-text-muted"
                      >
                        (minutes)
                      </span>
                    </div>
                    <span
                      className="uk-text-emphasis  uk-text-small"
                    >
                      {`${((selectedContent[contentUUID] || {}).recommendedTime || 0) / 60} min recommended`}
                    </span>
                  </div>
                  {!this.props.isHackedu && (
                    <Icon
                      onClick={(e) => {
                        e.stopPropagation()
                        this.props.onRemoveContent(contentUUID)
                      }}
                      className="uk-margin-right"
                      name="delete-bin"
                    />
                  )}
                </div>
              </li>
            )
          })
        }
      </ul>
    )
  }

  render() {
    return (
      <div style={{ width: 750 }}>
        {this.renderSortableContent()}
      </div>
    )
  }
}

export default SortCustomAssessmentContent
